export const FASHION_SUBS = [
  "Tops",
  "Short Top",
  "Skirt Tops",
  "Kurti",
  "Kurti Pant Set",
  "Kurti Pant Set with Dupatta",
  "Coord Sets",
  "Double Piece Dress",
  "Dress",
  "Loungewear",
  "Cotton Silk Sets",
];

export const FURNISHING_SUBS = [
  "Superkingsize Bedsheets with Pillow Cover",
  "Kingsize Bedsheets with Pillow Cover",
  "Queensize Bedsheets with Pillow Cover",
  "Two Sets of Bedsheets with Single Pair",
  "Quilts",
  "Comforters",
  "Kids Bedsheets",
  "Nightsuits",
];

export const MUMKEY_SUBS = ["Midi Dresses", "Tops", "Kaftans", "Co-ord & Kurta Sets"];

export const SUBS_BY_SECTION = { fashion: FASHION_SUBS, furnishing: FURNISHING_SUBS, mumkey: MUMKEY_SUBS };

export const isMumkey = (p) => p?.category === "mumkey";

export const sectionLabel = (section) =>
  section === "fashion" ? "Fashion Wear" : section === "furnishing" ? "Home Furnishing" : section === "mumkey" ? "Mumkey" : "All";

export const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");
